import React from 'react'
import PropTypes from 'prop-types'
import { StartPopupAd } from '@/features/preview/components'


const AdPreviewStartPopupType = ({ imageUrl }) => (
  <StartPopupAd
    imageUrl={imageUrl}
  />
)

AdPreviewStartPopupType.propTypes = {
  imageUrl: PropTypes.string.isRequired,
}

export default AdPreviewStartPopupType
